import styled from 'styled-components'
import PropTypes from 'prop-types'

import Tooltip from 'components/Tooltip'
import KeyboardAccessible from 'components/KeyboardAccessible'

import { color } from 'styles/colors'

const propTypes = {
  tooltipContent: PropTypes.string.isRequired,
  className: PropTypes.string
}

const defaultProps = {
  className: ''
}

const FieldExplanation = ({ tooltipContent, className }) => (
  <Tooltip title={tooltipContent} placement="top">
    <S.QuestionMarkIcon readOnly className={className + ' icon-question3'} />
  </Tooltip>
)

FieldExplanation.propTypes = propTypes
FieldExplanation.defaultProps = defaultProps

export default FieldExplanation

const S = {
  QuestionMarkIcon: styled(KeyboardAccessible)`
    color: ${color('questionMarkIcon')};
    padding: 5px;
  `
}
